import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import stamped from "../Assets/Image/stampedNonferrous1.jpg";
import { useNavigate } from "react-router-dom";
import { IoMdArrowRoundBack } from "react-icons/io";
import { Helmet } from "react-helmet";

const productTypes = [
  "Copper Stamped Parts",
  "Brass Stamped Components",
  "Aluminum Non-Ferrous Stampings",
  "Beryllium Copper Contact Terminals",
  "Custom Electrical Connectors",
  "Precision Washers and Shims",
  "Non-Ferrous Busbar Connectors",
  "Stamped Lugs and Clips",
];

const StampedPartsNonFerrous = () => {
  const navigate = useNavigate();

  return (
    <>
     <Helmet>
        <title>Stamped Parts – Non Ferrous | Delta Engineering</title>
        <meta
          name="description"
          content="Precision-engineered stamped non-ferrous parts crafted from copper, brass, and aluminum. Offering high conductivity, corrosion resistance, and reliability for electrical, automotive, and industrial systems."
        />
        <meta
          name="keywords"
          content="Stamped Parts Non Ferrous, Copper Stamped Components, Brass Stamping, Aluminum Stamped Parts, Beryllium Copper Terminals, Electrical Connectors, Non Ferrous Washers, Precision Shims, Electrical Busbar Connectors"
        />

        {/* Open Graph / Facebook */}
        <meta
          property="og:title"
          content="Stamped Parts – Non Ferrous | Delta Engineering"
        />
        <meta
          property="og:description"
          content="High-quality stamped non-ferrous parts including copper, brass, aluminum, and beryllium copper components for switchgear, automotive, and electrical applications."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.yourdomain.com/stamped-parts-non-ferrous"
        />
        <meta
          property="og:image"
          content="https://www.yourdomain.com/images/stamped-parts-non-ferrous.jpg"
        />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Stamped Parts – Non Ferrous | Delta Engineering"
        />
        <meta
          name="twitter:description"
          content="Precision non-ferrous stamped components offering high conductivity, corrosion resistance, and dimensional accuracy for industrial and electrical systems."
        />
        <meta
          name="twitter:image"
          content="https://www.yourdomain.com/images/stamped-parts-non-ferrous.jpg"
        />
      </Helmet>
      
      <section className="productbanner1 d-flex align-items-center position-relative">
        <div className="overlay-layer"></div>
        <Container className="text-center position-relative z-2">
          <Row className="justify-content-center">
            <Col lg={8} className="hero-content text-center">
              <h2
                className="hero-title"
                data-aos="zoom-in"
                data-aos-delay="300"
              >
               <span className="blue-text">Stamped Parts – </span>{" "}
            <span className="white-text">Non Ferrous</span>
              </h2>
              <p
                className="hero-subtitle"
                data-aos="zoom-in"
                data-aos-delay="200"
              >
               High-quality non-ferrous components offering excellent conductivity, corrosion resistance, and reliability for electrical and industrial systems.
              </p>
            </Col>
          </Row>
        </Container>
      </section>
      
      <section className="py-3" style={{ position: "relative" }}>
        <Button onClick={() => navigate("/ourproducts")} className="back-btn">
          <IoMdArrowRoundBack className="back-icon" />
          Back
        </Button>
        <Container>
          <div className="text-center mb-5">
            <h3 className="fw-bold section-title position-relative d-inline-block">
              Stamped Parts – Non Ferrous
              <span className="title-underline"></span>
            </h3>
            <p className="text-center text-muted mb-4">
              We specialize in precision non-ferrous stamped components that
              cater to electrical, automotive, and industrial demands. With
              state-of-the-art stamping technology, we manufacture intricate
              parts with superior precision, repeatability, and finish.
            </p>
          </div>

          <Row className="align-items-center mb-5">
            <Col md={4}>
              <img
                src={stamped}
                alt="Stamped Non-Ferrous Parts"
                className="img-fluid rounded shadow"
              />
            </Col>
            <Col md={8}>
              <h4 className="mb-3">Overview</h4>
              <p>
                Stamped parts made from non-ferrous metals like copper, brass,
                and aluminum are essential in delivering excellent electrical
                conductivity and mechanical strength. These components are
                commonly used in switchgear, connectors, terminals, and other
                applications where non-magnetic, corrosion-resistant materials
                are required.
              </p>
              <p>
                Our components undergo rigorous quality control and can be
                customized to meet client-specific requirements including
                thickness, plating, and dimensional tolerances.
              </p>
            </Col>
          </Row>

          <h4 className="mt-5">Key Features</h4>
          <ul>
            <li>High dimensional accuracy for complex geometries</li>
            <li>
              Crafted from premium non-ferrous materials like copper, brass, and
              aluminum
            </li>
            <li>Excellent conductivity and corrosion resistance</li>
            <li>Various surface finishes available: Tin, Nickel, Silver</li>
            <li>Customizable for volume production and specific tolerances</li>
          </ul>

          <h4 className="mt-5 mb-3">Product Types</h4>
          <Row>
            {productTypes.map((type, idx) => (
              <Col md={6} lg={4} key={idx} className="mb-3">
                <Card className="h-100 shadow-sm">
                  <Card.Body>
                    <Card.Text>{type}</Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>

          <h4 className="mt-5">Applications</h4>
          <ul>
            <li>Switchgear and control panels</li>
            <li>Automotive connectors and terminals</li>
            <li>Battery interconnections and lugs</li>
            <li>Electrical distribution and grounding</li>
            <li>Electronic subassemblies and precision shims</li>
          </ul>
        </Container>
      </section>
    </>
  );
};

export default StampedPartsNonFerrous;
